import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter, nazeegTypeOptions }) {
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [newMember, setNewMember] = useState({
    first_name: "",
    last_name: "",
    idz: "",
    gender: "",
    birth_date: null,
    tel: "",
    email: null,
    job: "",
    job_place: "",
    Address: "",
    zipcode: 0,
    notes: "",
    active: true,
    nazeegType: 1,
  });

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMegdarType = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "jobs/megdartype/", {
          signal: controller.signal,
        });
        isMounted && setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getMegdarType();
  }, []);

  // handle change event

  const handleChangeNazeegType = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setNewMember((prevState) => ({
      ...prevState,
      nazeegType: value,
    }));
  };

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value, checked } = e.target;
    if (name === "active") {
      setNewMember((prevState) => ({
        ...prevState,
        active: checked,
      }));
    } else
      setNewMember((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/memberlist/",
          newMember,
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response.data.error) {
          alert(`Error: קיים חבר פעיל עם מספר ת"ז דומה`);
        } else if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>רשימת חברי ועדות הבחינה</h2>
            מתוכה ניתן לבחור חברי וועדת בחינה
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="first_name">שם פרטי</label>
                        <input
                          type="text"
                          name="first_name"
                          value={newMember.first_name}
                          onChange={handleChange}
                          className="form-control"
                          id="first_name"
                          placeholder="תקליד שם פרטי"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="last_name">שם משפחה </label>
                        <input
                          type="text"
                          name="last_name"
                          value={newMember.last_name}
                          onChange={handleChange}
                          className="form-control"
                          id="last_name"
                          placeholder=""
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="idz">תעודת זהות</label>
                        <input
                          type="text"
                          name="idz"
                          value={newMember.idz}
                          onChange={handleChange}
                          className="form-control"
                          id="idz"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="birth_date">תאריך לידה</label>
                        <input
                          type="date"
                          name="birth_date"
                          className="form-control"
                          id="birth_date"
                          value={newMember.birth_date}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="gender">מגדר</label>
                        <select
                          name="gender"
                          onChange={handleChange}
                          value={newMember.gender}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר סוג
                          </option>
                          {megdarOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="tel">טלפון</label>
                        <input
                          type="text"
                          name="tel"
                          value={newMember.tel}
                          onChange={handleChange}
                          className="form-control"
                          id="tel"
                          placeholder=""
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="email">דואר אלקטרוני</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          id="email"
                          value={newMember.email}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="Address">כתובת</label>
                        <input
                          type="text"
                          name="Address"
                          value={newMember.Address}
                          onChange={handleChange}
                          className="form-control"
                          id="Address"
                          placeholder=""
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="zipcode">מיקוד</label>
                        <input
                          type="number"
                          name="zipcode"
                          className="form-control"
                          id="zipcode"
                          value={newMember.zipcode}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="job">תפקיד</label>
                        <input
                          type="text"
                          name="job"
                          value={newMember.job}
                          onChange={handleChange}
                          className="form-control"
                          id="job"
                          placeholder=""
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="job_place">מקום עבודה</label>
                        <input
                          type="text"
                          name="job_place"
                          className="form-control"
                          id="job_place"
                          value={newMember.job_place}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div>
                        <label htmlFor="nazeegType">{`בחר סוג נציג: `} </label>
                        <select
                          id="nazeegType"
                          name="nazeegType"
                          onChange={handleChangeNazeegType}
                        >
                          {nazeegTypeOptions?.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-center flex-column align-items-center">
                        <label htmlFor="notes" className="mb-0">
                          הערות
                        </label>
                        <br />
                        <textarea
                          id="notes"
                          name="notes"
                          value={newMember?.notes}
                          onChange={handleChange}
                          className="mt-0"
                          style={{
                            resize: "none",
                            height: "150px",
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף חבר חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={newMember.first_name + " " + newMember.last_name}
                alertBody="חבר הוועדה נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
